import { ElementType, ReactNode } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import InboxOutlinedIcon from "@mui/icons-material/InboxOutlined";

export type EmptyStateProps = { icon?: ElementType; title: string; description?: ReactNode; actions?: ReactNode };

export default function EmptyState({ icon: Icon = InboxOutlinedIcon, title, description, actions }: EmptyStateProps) {
  return (
    <Box role="status" sx={{ py: 6, px: 2, textAlign: "center", maxWidth: 480, mx: "auto" }}>
      <Box sx={{ width: 56, height: 56, borderRadius: "50%", bgcolor: "#e0f7fc", display: "grid", placeItems: "center", mx: "auto", mb: 1.5 }}>
        <Icon sx={{ fontSize: 28, color: "#0592b5" }} aria-hidden />
      </Box>
      <Typography sx={{ fontWeight: 600, fontSize: 15 }}>{title}</Typography>
      {description && <Typography sx={{ color: "text.secondary", fontSize: 13, mt: 0.5 }}>{description}</Typography>}
      {actions && <Box sx={{ display: "flex", gap: 1, justifyContent: "center", flexWrap: "wrap", mt: 2 }}>{actions}</Box>}
    </Box>
  );
}
